<div [ngClass]="[ productListing ? 'product-listing-loader' : 'loader-container',fromCartPopup ? 'cart-loader':'']">
  <ion-item lines="none">
    <ion-spinner name="circular"></ion-spinner>
  </ion-item>
</div>